import styled from 'styled-components';
import { fonts } from 'styles';
import slide6 from 'assets/images/desktop/slide6.jpg';
import { Subtitle } from 'styles/shared';

export const Container = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: #111111;
`;

export const PhotoWrapper = styled.div`
  width: 100%;
  max-width: max-content;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img.attrs({ src: slide6 })`
  height: 100%;
`;

export const Captions = styled.div`
  width: 100%;
  max-width: 55%;
  height: 100vh;
  overflow-y: auto;
  display: flex;
`;

export const Staff = styled.div`
  width: 100%;
  padding: 10%;
`;

export const StaffHeadline = styled.h2`
  width: 100%;
  font-family: ${fonts.BentonSansWideBold};
  font-size: 14px;
  line-height: 22px;
  text-transform: uppercase;
  color: #fff;
  padding-bottom: 16px;
  border-bottom: 1px solid #fff;
  margin-bottom: 40px;
`;

export const StaffTextWrapper = styled.div`
  width: 100%;
  display: flex;
  column-gap: 48px;
`;

export const StaffText = styled.article`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 13px;
  line-height: 19px;
  color: #fff;
  width: 100%;
  text-align: left;

  p {
    margin-bottom: 32px;
    span {
      font-family: ${fonts.BentonSansRegular};
      font-size: 14px;
      line-height: 22px;
      color: #d4d4d4;
    }
  }

  a {
    text-decoration: underline;
    color: #fff;
  }
`;

export const CustomSubtitle = styled(Subtitle)`
  left: 4%;
  bottom: 4%;
  max-width: 260px; ;
`;
